import { render } from "./WatchlistDetailsModal.vue?vue&type=template&id=3aa69648&ts=true"
import script from "./WatchlistDetailsModal.vue?vue&type=script&lang=ts"
export * from "./WatchlistDetailsModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__